import React from "react";
import { Footer } from "../export";
import "./contact.css";
import { motion } from "framer-motion";

const Contact = () => {
  return (
    <motion.div
      className="app__contact"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div className="app__contact-details">
        <h1 className="h1__text3">For any questions please mail us:</h1>
        <h1 className="h1__text gradient__text">paul.ayeni0212@gmail.com</h1>
      </div>

      <div className="app__contact-bottom">
        <Footer />
      </div>
    </motion.div>
  );
};

export default Contact;
